// CSV download handler for the Downloads sub-tab.
//
// Bug fix: the original handler did NOT await fetcherFile, so `response`
// was always a Promise (truthy, no .error/.errors), making three of the
// four if/else branches dead code and leaking HTTP failures as unhandled
// promise rejections. fetcherFile throws ApiError on failure (it never
// returns {error} objects), so the four branches collapse cleanly into
// a try/catch around the awaited call.

import dayjs from "dayjs";
import { toast } from "react-toastify";

import { fetcherFile } from "utils/api";

const REPORT_TYPES = ["dump", "summary", "raw", "comprehend", "themes"];

// Toast options shared by success and error variants. Only `render` and
// `type` differ between the two paths.
const TOAST_UPDATE_OPTIONS = {
    isLoading: false,
    autoClose: 5000,
    pauseOnFocusLoss: false,
    pauseOnHover: false,
    closeOnClick: true,
    closeButton: true,
};

export function useReportDownload({ survey, surveyId }) {
    const csvDownloadHandler = async (type) => {
        if (!REPORT_TYPES.includes(type)) {
            toast.error("Invalid Report Format!");
            return;
        }
        const csvDownloadToast = toast.loading("Downloading CSV...");
        const fileName = `${survey.name}_${type}_report_${dayjs().format(
            "YYYYMMDD-HHmm",
        )}.csv`;
        try {
            await fetcherFile(
                `/v2/survey/${surveyId}/report/${type}.csv`,
                "GET",
                fileName,
            );
            toast.update(csvDownloadToast, {
                ...TOAST_UPDATE_OPTIONS,
                render: "CSV Downloaded",
                type: "success",
            });
        } catch (err) {
            toast.update(csvDownloadToast, {
                ...TOAST_UPDATE_OPTIONS,
                render: `Error Downloading CSV: ${err.message}`,
                type: "error",
            });
        }
    };

    return { csvDownloadHandler };
}
